import { TransientStorageService } from "@twii/common/lib/service/TransientStorageService";
import { LoggingStorageService } from "@twii/common/lib/service/LoggingStorageService";
var DefaultStorageServiceFactory = function () {
    return new LoggingStorageService({ target: new TransientStorageService(), prefix: "transientStorage" });
};
export { DefaultStorageServiceFactory };
